





































































import { Component, Prop, Vue } from "vue-property-decorator";
import { technologies, Technology } from "./Technology";

@Component
export default class ProjectDetails extends Vue {
    @Prop() description?: string;
    @Prop() skills?: string[];
    @Prop() stack?: Technology;

    get flexRow() {
        return this.skills && this.stack;
    }

    public nameOfTech(tech: Technology) {
        return technologies[tech].name;
    }

    public srcForTech(tech: Technology) {
        return technologies[tech].src;
    }

    public urlForTech(tech: Technology) {
        return technologies[tech].url;
    }
}
